<body class="otp-modal-body">
  <div class="container-fluid p-3 h-100">
    <div class="row justify-content-center align-items-center h-100">
      <!-- Changed col-md-5 → col-md-4, col-sm-8 → col-sm-6 -->
      <div class="col-12 col-sm-6 col-md-4">
        <div class="innerDiv bg-white rounded shadow">
          <a class="closeLink" (click)="onClose()" aria-label="Close">
            &times;
          </a>
          <h3 class="head mb-2 p-1 text-center">OTP Verification</h3>
          <p class="text-muted text-center">
            Please enter the 4-digit verification code that was sent to
            {{customerType ? customerType :'customer'}} email or phone number.
            The code is valid for 3 minutes.
          </p>

          <form [formGroup]="otpForm">
            <div class="otp">
              <ng-otp-input
                (onInputChange)="onOtpChange($event)"
                [config]="{length:4}"
              ></ng-otp-input>

              <!-- Timer + Resend OTP -->
              <div class="timer-resend mt-3 text-center">
                <p class="mb-0">{{remainingTime}}</p>
                <a class="res-otp" (click)="resendOTPService()" *ngIf="isExpire && isService">Resend OTP</a>
                <a class="res-otp" (click)="resendOtp()" *ngIf="isExpire && !isService">Resend OTP</a>
                <a class="res-otp text-muted" style="cursor: not-allowed;" *ngIf="!isExpire">Resend OTP</a>
              </div>
            </div>

            <!-- Submit Buttons -->
            <div class="vca mt-3" *ngIf="!custom">
              <ng-container *ngIf="!loading">
                <button
                  class="o-f"
                  *ngIf="!isService"
                  (click)="load();verifyOTP()"
                  [disabled]="!otp || otp?.length !== 4"
                >
                  SUBMIT
                </button>
                <button
                  class="o-f"
                  *ngIf="isService"
                  (click)="load();verifyOTPService()"
                  [disabled]="!otp || otp?.length !== 4"
                >
                  SUBMIT
                </button>
              </ng-container>
              <ng-container *ngIf="loading">
                <button class="o-f op05" disabled>Loading...</button>
              </ng-container>
            </div>

            <div class="vca mt-3" *ngIf="custom">
              <button
                class="o-f"
                *ngIf="!loading"
                (click)="load();onSumbitOtp()"
                [disabled]="!otp || otp?.length !== 4"
              >
                SUBMIT
              </button>
              <button class="o-f op05" *ngIf="loading" disabled>Loading...</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</body>
